/* unplugin-vue-components disabled */import { render } from "./DemoHome.vue?vue&type=template&id=15a0ea98&scoped=true&ts=true"
import script from "./DemoHome.vue?vue&type=script&lang=ts"
export * from "./DemoHome.vue?vue&type=script&lang=ts"

import "./DemoHome.vue?vue&type=style&index=0&id=15a0ea98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a0ea98"]])

export default __exports__